// extracted by css-extract-rspack-plugin
export default {"box":"box-Ec8tFK"};